import HeaderButtonsContainerContext from '@contexts/headerSearchBar'
import { useContext } from 'react'

const useHeaderSearchBar = () => useContext(HeaderButtonsContainerContext)

export default useHeaderSearchBar
